const convertToDDMMYYYY = (isoDateStr) => {
  const date = new Date(isoDateStr);
  const dd = String(date.getDate()).padStart(2, "0");
  const mm = String(date.getMonth() + 1).padStart(2, "0"); // Months index from 0
  const yyyy = date.getFullYear();
  // console.log(dd + mm + yyyy);
  return dd + "/" + mm + "/" + yyyy;
};
const yyyymmdd2ddmmyyyy = (dateString) => {
  if (!dateString) return "";
  return dateString.split("-").reverse().join("-");
};


export { convertToDDMMYYYY,yyyymmdd2ddmmyyyy };